import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ToggleSwitch from "./Toggle";
import { useStaffMode } from "../../../hooks/StaffModeProvider";
import AuthContext from "../../../store/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { Appstore, setExtraMenuIsOpen } from "../../../redux";
import { logout } from "../../../utils/logout";
import UserIcon from "../../Atomos/Icons/EditMode/UserIcon";
import Logout from "../../Atomos/Icons/Logout";
import WorldServicesGroupIcon from "../../Atomos/Icons/WorldServicesGroupIcon";
import {
  isHelpCenterStaff,
  resolveWsgPermission,
} from "../../../pages/HelpCenter/helpCenterPermissions";

const HeaderExtra = () => {
  const { isStaffMode } = useStaffMode();
  const { loggedPerson, setIsAuthenticated, tokenDecoded } =
    useContext(AuthContext);
  const permission = resolveWsgPermission(
    tokenDecoded?.extension_WSG_Permissions,
  );
  const isStaff = isHelpCenterStaff(permission);
  const isOpen = useSelector((state: Appstore) => state.menus.extraMenuIsOpen);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setExtraMenuIsOpen(false));
  }, [dispatch, pathname]);

  useEffect(() => {
    const iconElement = document.getElementById("favicon");
    const icon = isStaffMode ? "/favicon_staff.png" : "/favicon.png";
    iconElement?.setAttribute("href", icon);
  }, [isStaffMode]);

  const handleLogout = () => {
    logout();
    setIsAuthenticated(false);
  };

  useEffect(() => {
    const syncLogout = (event: StorageEvent) => {
      if (event.key === "logout") {
        logout();
        setIsAuthenticated(false);
      }
    };

    window.addEventListener("storage", syncLogout);
    return () => window.removeEventListener("storage", syncLogout);
  }, [setIsAuthenticated]);

  const options = [
    {
      name: 'My Profile',
      action: () => navigate(`/profile/${loggedPerson?.name}/${loggedPerson?.legacyId ?? loggedPerson?.generatedId}`),
      icon: <UserIcon/>
    },
    {
      name: 'My WSG',
      action: () => navigate("/mywsg"),
      icon: <WorldServicesGroupIcon/>
    },
    {
      name: 'Logout',
      action: () => handleLogout(),
      icon: <Logout/>
    }
  ];

    const renderNavigationLinks = () => {
    return (
      <ul className="flex gap-5 md:gap-10 flex-col-reverse md:flex-row justify-center items-start md:items-center">
        {options.map((o, index) => (
          <li key={index} className="relative group cursor-pointer py-4 h-full">
            <button 
              onClick={o.action}
              className={`hover:${isStaffMode ? 'text-secondary-dark' : 'text-primary-dark'} hover:scale-105
                flex relative h-full transition-colors duration-300`}
            >
              <div className="flex justify-center w-6 h-6 mx-4 md:mx-1">{o.icon}</div>
              <span className="flex justify-center">{o.name}</span>
            </button>
          </li>
        ))}
        {renderStaffToggle()}
      </ul>
    );
  };

  const renderStaffToggle = () => {
    if (!isStaff) {
      return null;
    }

    return (
      <div className={`md:order-2 transition-opacity duration-300 ${isOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}>
        <ToggleSwitch IsStaffNavigate={isStaffMode} onToggle={() => {}} />
      </div>
    );
  };

  return (
    <div
      className={`flex text-gray-font text-lg font-medium roboto_font transition-opacity duration-300`}
    >
      {renderNavigationLinks()}
    </div>
  );
};

export default HeaderExtra;
